export type AppPublicationFields = 'basic'

// eslint-disable-next-line unused-imports/no-unused-vars
export const appPublicationGQLFields = (fields: AppPublicationFields) => {
  return `
    id
    addedById
    itemId
    networkId
    createdAt
  `
}
